<template>
  <div class="row col-12 justify-between align-center page-header">
    <!-- Ícone voltar + Título -->
    <div class="row items-center">
      <q-icon
        name="arrow_back_ios"
        color="brand-1"
        class="icon-voltar cursor-pointer"
        @click="handleBack"
      />
      <span :class="titleClass">
        <slot name="title">{{ title }}</slot>
      </span>
      <slot name="actions" class="q-ml-md"></slot>
    </div>

    <!-- Espaço flexível + Botão Voltar -->
    <div class="row items-center">
      <!-- Botão Voltar padrão -->
      <div @click="handleBack" no-caps flat class="btn-voltar-header">
        <div class="row items-center button-voltar-header">
          <q-icon name="west" color="brand-5" size="16px" class="q-mr-xs" />
          <span class="text-brand-5">Voltar</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";

export default {
  name: "PageHeader",
  props: {
    title: {
      type: String,
      required: true,
    },

    titleClass: {
      type: String,
      default: "text-h6 text-brand-1 text-weight-bolder",
    },

    backBehavior: {
      type: String,
      default: "smart",
      validator: (value) => ["history", "smart", "route"].includes(value),
    },

    backRoute: {
      type: [String, Object],
      default: null,
    },
  },

  setup(props) {
    const router = useRouter();

    const getParentRoute = () => {
      const currentRoute = router.currentRoute.value;

      if (currentRoute.meta?.parent) {
        return { name: currentRoute.meta.parent };
      }

      if (currentRoute.matched && currentRoute.matched.length > 1) {
        const parentRoute =
          currentRoute.matched[currentRoute.matched.length - 2];
        if (parentRoute?.name) {
          return { name: parentRoute.name };
        }
      }

      return null;
    };

    const handleSmartBack = async () => {
      try {
        router.go(-1);
      } catch (error) {
        const parentRoute = getParentRoute();

        if (parentRoute?.name) {
          await router.push(parentRoute);
        } else {
          await router.push({ name: "home" });
        }
      }
    };

    const handleBack = async () => {
      try {
        await new Promise((resolve) => setTimeout(resolve, 1000));

        switch (props.backBehavior) {
          case "history":
            router.go(-1);
            break;

          case "route":
            if (props.backRoute) {
              await router.push(props.backRoute);
            } else {
              await router.push({ name: "home" });
            }
            break;

          case "smart":
          default:
            await handleSmartBack();
            break;
        }
      } catch (error) {
        console.warn("Erro ao navegar:", error);
        await router.push({ name: "home" });
      }
    };

    return {
      handleBack,
    };
  },
};
</script>

<style scoped>
.page-header {
  padding: 16px 0;
  margin-bottom: 12px;
}

.icon-voltar {
  cursor: pointer;
  transition: all 0.3s ease;
}

.icon-voltar:hover {
  transform: translateX(-2px);
}

.btn-voltar-header {
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.2s ease;
  user-select: none;
  font-size: 16px;
  color: var(--q-color-brand-5) !important;
}

.btn-voltar-header:hover {
  background-color: none;
}

.texto-voltar {
  font-weight: 500;
  font-size: 14px;
}
</style>
